export const GET_KEYPOINT_DATA='GET_KEYPOINT_DATA';
export const GET_KEYPOINT_DATA_ERROR='GET_KEYPOINT_DATA_ERROR';
export const GET_KP_DATASET_DATA='GET_KP_DATASET_DATA';
export const GET_KP_DATASET_DATA_ERROR='GET_KP_DATASET_DATA_ERROR';


// WEBPACK FOOTER //
// ./src/redux/keypoint/actionTypes.js